import styled from 'styled-components';

const WrapPreview = styled.div`
  margin-top: 10px;

  .previewWindow {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
`;

const WrapButton = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 10px;
  .ant-btn {
    &:first-child {
      margin-right: 10px;
    }
  }
`;

const WrapHighWarnning = styled.div`
  padding: 5px;
  background-color: red;
  color: white;
  font-weight: bold;
  display: inline-block;
`;

const WrapAlert = styled.div`
  margin-top: 5px;
  .reset-button {
    width: 100%;
    text-align: right;
    margin-top: 10px;
  }
`;

const WrapConfirmPreview = styled.div`
  position: relative;
`;

export {
  WrapButton,
  WrapPreview,
  WrapConfirmPreview,
  WrapAlert,
  WrapHighWarnning
};



// WEBPACK FOOTER //
// ./src/components/preview/index.styled.tsx